import { useQuery } from 'react-query';

import {
  EmailSettings,
  USER_EMAIL_SETTINGS_KEY,
  getEmailSettings,
} from '../utils/backend-api/settings';

export default function useEmailSettings() {
  const { data, isLoading: isLoadingUserEmailSettings } = useQuery<EmailSettings>(
    USER_EMAIL_SETTINGS_KEY,
    () => getEmailSettings()
  );

  return { userEmailSettings: data, isLoadingUserEmailSettings };
}
